import styled from 'styled-components';

export const QuickUploadPrescriptionStyled = styled.div`
  width: 100%;
  display: flex;
  margin-top: 8px;
  margin-bottom: 16px;

  .titleBar {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    margin: 20px 0;
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
  }

  .uploadBox {
    width: 100%;
    border: 1px solid ${(props) => props.theme.color.divider};
    background: linear-gradient(
      97.43deg,
      #ffffff -7.44%,
      ${(props) => props?.theme?.green?.gradientLight}6E 5.38%,
      ${(props) => props?.theme?.green?.gradientDark} 98%
    );
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 18px;
    margin: 8px 0 0 0;

    .leftArea {
      display: flex;
      align-items: center;

      .ic {
        margin: 0 18px 0 0;
        display: flex;
      }

      .text {
        color: ${(props) => props?.theme?.color?.white};
        font-size: 17px;
      }
    }

    .rightArea {
      display: flex;
      justify-content: flex-end;
      a{
        text-decoration: none;
      }

      .btn {
        width: 200px;
        color: ${(props) => props?.theme?.teal?.dark};
        background: ${(props) => props?.theme?.color?.white};
        border-color: ${(props) => props?.theme?.color?.white};
        margin: 0;
        text-decoration: none;
       
        &:hover {
          color: ${(props) => props?.theme?.color?.white};
          background: ${(props) => props?.theme?.green?.light};
          border-color: ${(props) => props?.theme?.green?.light};
        }
      }
    }

    &.homecare {
      margin: -4px 0 30px 0;
      background: linear-gradient(
        97.43deg,
        ${(props) => props?.theme?.color?.white} -7.44%,
        rgba(52, 71, 124, 0.43) 5.38%,
        ${(props) => props?.theme?.royalBlue?.dark} 98%
      );

      .leftArea {
        .text {
          font-size: 16px;
          line-height: 24px;
        }
      }

      .rightArea {
        .btn {
          color: ${(props) => props?.theme?.royalBlue?.dark};
          background: ${(props) => props?.theme?.color?.white};
          border-color: ${(props) => props?.theme?.color?.white};
          &:hover {
            color: ${(props) => props?.theme?.royalBlue?.dark};
            background: ${(props) => props?.theme?.color?.white};
            border-color: ${(props) => props?.theme?.color?.white};
          }
        }
      }
    }
  }

  @media (max-width: 820px) {
    .uploadBox {
      margin: 15px 0;
    }
  }
  @media (max-width: 480px) {
    .uploadBox {
      padding: 12px;

      .leftArea {
        .ic {
          margin: 0;
          width: 55px;
        }
        .text {
          margin-left: 14px;
          

          strong {
            font-size: 16px;
            font-weight: 700;
          }

          span {
            width: 100%;
            /* color: ${(props) => props.theme.text.medium}; */
            font-size: 14px;
            font-weight: 400;
            display: flex;
          }
        }
      }
      .rightArea {
        display: flex;
        .btn {
          width: 120px;
          font-size: 13px;
          padding: 10px;
        }
      }
    }
  }
  
`;
